import {
	Model,
	YardSchedule
} from ".";

export default class ScheduleType extends Model {
	get singularNoun() {
		return "schedule type";
	}

	get mutations() {
		return {
			schedules: YardSchedule
		};
	}

	resource() {
		return "yard/schedule-types";
	}
}
